import { gsap } from '../vendor/gsap';
import animateOnScroll from '../lib/animateOnScroll';
import windowSize from '../lib/windowSize';

const sectionSelector = '.foundations-section, .text-content-section, .text-content-with-divider-section, .portfolio-section, .news-section, .strategy-section, .team-section-content, .numbers-section, .values-scheme-section, .strategy-scheme-section, .divider-line-section';
const sectionCallBack = (sectionElement, query, queryAll) => {
    const titles = queryAll('.section-title > *, .strategy-scheme-head > *, .strategy-scheme-foot > *, .section .hint');
    const lines = queryAll('.divider-line-section .line');
    const boxes = queryAll('.foundations-col, .text-content,.portfolio-col, .news-list-row, .strategy-post-col, .team-section-position, .numbers-section-col, .values-scheme-col, .strategy-scheme-col');
    const timeline = gsap.timeline({
        paused: true,
    });
    timeline.addLabel('start');
    timeline.fromTo(titles, { opacity: 0 }, {
        opacity: 1, stagger: 0.2, duration: 0.5, ease: 'easeOut',
    }, 'start+=0.2');
    timeline.fromTo(lines, { scaleX: 0 }, {
        scaleX: 1, stagger: 0.2, duration: 1, ease: 'easeOut',
    }, 'start+=0.4');
    timeline.fromTo(boxes, { opacity: 0 }, {
        opacity: 1, stagger: 0.2, duration: 0.5, ease: 'easeOut',
    }, 'start+=0.3');
    animateOnScroll(sectionElement, () => timeline.play(), () => windowSize.height * 0.1);
};

export { sectionSelector, sectionCallBack };
